export default "__VITE_ASSET__Br5lSEa6__"